import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get, post } from '../util/request';
import { format } from 'date-fns';
import { logout } from '../redux/action/auth.action';
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [state, setState] = useState({
    attendanceList: '',
    notificationCount: '',

    startDate: format(new Date(), "yyyy-MM-dd"),
    loading: true
  })

  const [datas, setDatas] = useState({
    lat: "",
    lng: "",
    address: "",
  });

  const jwtToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)

  useEffect(() => {
    let isMounted = true
    if (isMounted) {

      getAttendanceList()
      getNotificationCount()
    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {
    const today = new Date().toLocaleDateString();
    const storedDate = localStorage.getItem('storedDate');

    if (storedDate !== today) {
      localStorage.removeItem('absenSuccess');
      localStorage.setItem('storedDate', today);
      window.location.reload();
    }
  }, []);

  const getLocation = () => {
    if (!navigator.geolocation) {
      console.log("Geolocation is not supported by your browser");
    } else {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords;
            const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
            const response = await fetch(url);
            const data = await response.json();
            if (data.display_name) {
              setDatas({
                ...datas,
                lat: latitude,
                lng: longitude,
                address: data.display_name,
              });
            } else {
              console.log("Address not found in response:", data);
            }
          } catch (error) {
            console.error("Error fetching address:", error);
          }
        },
        () => {
          console.log("Unable to retrieve your location");
        }
      );
    }
  };

  useEffect(() => {
    getLocation()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const getAttendanceList = () => {
    get(
      `public/api/v1/member/attendance/list?company_id=${user.company_id}&date=${state.startDate}`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState(prevState => {
          return {
            ...prevState,
            // tasksList: success.data.Data,
            attendanceList: success.data.Data,
            loading: false
          }
        })
      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const getNotificationCount = () => {
    get(
      `public/api/v1/notification-count?employeeId=1&companyId=1`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      },
      success => {
        setState(prevState => {
          return {
            ...prevState,
            // tasksList: success.data.Data,
            notificationCount: success.data.Data,
            loading: false
          }
        })
      },
      error => {
        if (error.status === 401) {
          dispatch(logout())
        }
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const absenDone = () => {
    const formData = new FormData();
    formData.append("company_id", user?.company_id);
    formData.append("employee_id", user?.employee_id);
    formData.append("lat", datas?.lat);
    formData.append("lng", datas?.lng);
    formData.append("address", datas?.address);
    formData.append("image", user?.profile?.employee_avatar);
    formData.append("type", 1);

    post(
      `public/api/v1/member/attendance/submit`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "multipart/form-data",
        },
      },
      formData,
      (success) => {
        alert("berhasil pulang");
        // navigate("/");
        window.location.reload();
        console.log("success logout absen", success);
      },
      (error) => {
        console.log('error request', error)
        alert(error?.data?.Message);
      }
    );
  }

  return (
    <div className='relative w-full h-screen grid-cols-1 sm:grid-cols-2 bg-red-bg'>
      <div className='container p-8 text-white'>
        <div className='flex justify-between'>
          <p className='text-xl'>Hai, {user.employee_fullname}</p>
          <div className='flex justify-end gap-2'>
            <a href={process.env.PUBLIC_URL + "/notification"} className="relative flex justify-center w-12 h-12 text-xs font-medium text-center text-black rounded-full bg-real-white">
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/notif.svg"} className='justify-start w-4 m-auto' />
              <div className='absolute p-2 text-white rounded-full left-6 bottom-8 bg-orange-bg'>{state.notificationCount.unread_total}</div>
            </a>
            <a href={process.env.PUBLIC_URL + "/profile"} className="flex justify-center w-12 h-12 py-2 text-xs font-medium text-center text-black rounded-full bg-real-white">
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/profile.svg"} className='justify-start w-4 m-auto' />
            </a>
          </div>
        </div>

        <p className='text-base'>Semoga Harimu Menyenangkan</p>
        <div className='flex items-start'>
          <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/pin.svg"} className='justify-start w-4 py-1' />
          <span className=''>Bintaro sektor 3, mandar utama III, Kota Tangerang Selatan
          </span>
        </div>
      </div>
      <div className='absolute bottom-0 w-full bg-primary rounded-t-3xl h-2/3'> </div>
      <div className='absolute bottom-0 w-full top-48 '>
        <div className='flex justify-around rounded-3xl h-1/4'>
          <a href={process.env.PUBLIC_URL + "/info"} className='w-5/12'>
            <div className='h-full bg-local bg-real-white bg-opacity-5 rounded-xl' style={{ backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/img/bg-home-1.png"})` }}>
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/icon-file.svg"} className='justify-start w-16 py-1' />
              <p className='px-2 font-bold text-md'>Informasi dan Berita</p>
              <p className='px-2 text-xs'>info tentang hari ini</p></div>
          </a>
          <a href={process.env.PUBLIC_URL + "/rencana-izin"} className='w-5/12'>
            <div className='h-full bg-blue-200 rounded-xl' style={{ backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/img/bg-home-2.png"})` }}>
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/icon-file.svg"} className='justify-start w-16 py-1' />
              <p className='px-2 font-bold text-md'>Rencana dan Tiba-tiba</p>
              <p className='px-2 text-xs'>saya ada rencana izin</p></div>
          </a>

        </div>
        <div className='flex justify-center w-full px-4 mt-4 bg-local rounded-3xl h-1/5'>
          {localStorage.getItem('absenSucces') === undefined || localStorage.getItem('absenSucces') !== "SUCCESS"   ? (
            <div className='w-full h-full pt-4 text-center bg-real-white shadow-all rounded-xl'>
              <p className='text-sm'>Klik Tombol <span className='text-red-bg'>ABSEN SEKARANG</span>
                <p>untuk memulai absensi harian anda</p> </p>
              <div className="w-full px-8 pt-4">
                <a
                  href={process.env.PUBLIC_URL + "/absen"}
                  // type="submit"
                  className="block rounded-full bg-gradient-to-b from-red-light-bg to-orange-bg hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  ABSEN SEKARANG
                </a>
              </div>
            </div>
          ) : (
            <div className='w-full h-full py-4 text-center bg-real-white shadow-all rounded-xl'>
              <p className='text-sm'>Selamat anda sudah tercatat <p>absen untuk hari ini <span className='text-red-bg underline cursor-pointer' onClick={() => navigate("/list-absen")}>Lihat Detail</span></p></p>
              <div className="w-full px-8 pt-4">
                <button
                  onClick={() => absenDone()}
                  className="block rounded-full w-full border-2 bg-real-white border-red-400 hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg px-3.5 py-2.5 text-center text-sm font-semibold text-black shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Pulang
                </button>
              </div>
            </div>
          )}

        </div>
        <div className='bottom-0 flex justify-center w-full px-4 mt-4 bg-local rounded-3xl h-1/6'>
          <a href={process.env.PUBLIC_URL + "/list-absen"} className='w-full h-full px-4 pt-4 bg-cover bg-blue-dark shadow-all rounded-xl' style={{ backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/img/bg-home-3.svg"})` }}>
            <div className='flex justify-between'>
              <div>
                <p className='text-lg font-bold text-white'>Lihat Absensi harian  </p>
                <p className='text-sm text-white'>Sudah absen hari ini <span>{state.attendanceList.total_attendance_success}</span>  </p>
              </div>

              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/icon-play.svg"} className='justify-start w-8 py-1' />
            </div>
          </a>
        </div>
        <div className='grid grid-cols-2 mt-4 h-1/4'>

          <div className="w-full px-4 pt-4">
            <a
              href={process.env.PUBLIC_URL + "/tugas-kerja"}
              // type="submit"
              className="block h-full text-black rounded-lg shadow-all bg-real-white"
            >
              <div className='flex items-center h-full px-4 place-items-center'>
                <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/icon-file.svg"} className='justify-start w-8 py-1' />
                <p className='text-sm font-semibold text-grey-dark'>Tugas Kerja</p>
              </div>
            </a>

          </div>
          <div className="w-full px-4 pt-4">
            <a
              href={process.env.PUBLIC_URL + "/laporan-kerja"}
              // type="submit"
              className="block h-full text-black rounded-lg shadow-all bg-real-white"
            >
              <div className='flex items-center h-full px-4 place-items-center'>
                <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/icon-file.svg"} className='justify-start w-8 py-1' />
                <p className='text-sm font-semibold text-grey-dark'>Laporan Kerja </p>
              </div>
            </a>

          </div>
          <div className="w-full px-4 pt-4">
            <a
              href={process.env.PUBLIC_URL + "/payroll"}
              // type="submit"
              className="block h-full text-black rounded-lg shadow-all bg-real-white"
            >
              <div className='flex items-center h-full px-4 place-items-center'>
                <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/icon-money.svg"} className='justify-start w-8 py-1' />
                <p className='text-sm font-semibold text-grey-dark'>Payroll</p>
              </div>
            </a>

          </div>

        </div>
      </div>



    </div >
  )
}

export default Home